// extracted by mini-css-extract-plugin
module.exports = {"root":"BooksPaymentMethods_root__i2FkF","payment_item":"BooksPaymentMethods_payment_item__SvSr_"};